import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DateFilterDialogModel} from "./date-filter-dialog.model";
import {UntypedFormBuilder, FormControl, UntypedFormGroup, Validators} from "@angular/forms";
import moment from "moment";
import {DurationInputArg2} from "moment";

@Component({
    selector: 'app-date-filter-dialog',
    templateUrl: './date-filter-dialog.component.html',
    styleUrls: ['./date-filter-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateFilterDialogComponent implements OnInit {

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<DateFilterDialogModel>,
    @Inject(MAT_DIALOG_DATA) public data: DateFilterDialogModel) {
  }

  form: UntypedFormGroup;

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      periodFrom: ['', Validators.required],
      periodTo: ['', Validators.required],
    });
    this.form.setValue({
      periodFrom: this.data.periodFrom || moment().add(-1, 'months').toDate(),
      periodTo: this.data.periodTo || moment().toDate()
    })
  }

  setRange(range: DurationInputArg2) {
    this.dialogRef.close({
      periodFrom: moment().add(-1, range).toDate(),
      periodTo: moment().toDate()
    });
  }
}
